import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://ae516d10-53f1-4dac-8b24-eedcf6dff882.preview.emergentagent.com";
const DEFAULT_TITLE = "Elliott International Development — Luxury Real Estate · Tampa, Florida";
const DEFAULT_DESC = "Elliott International Development LLC — Tampa-based developer of iconic mixed-use towers, ultra-luxury condominiums, hospitality, and transformational urban environments. Flagship: Elliott Towers.";
const DEFAULT_OG = `${SITE_URL}/og-default.jpg`;

export default function SEO({ title, description, path = "/", image, type = "website" }) {
  const fullTitle = title ? `${title} · Elliott International Development` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${path}`;
  const og = image || DEFAULT_OG;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={og} />
      <meta property="og:site_name" content="Elliott International Development" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={og} />
    </Helmet>
  );
}
